import { USER_PREFERENCE_SETS } from '../../../common/utils/constants';
import { localChartPlaceholder } from 'redux/UserPreferences/constants';

export const fallbackByCategory = {
  [USER_PREFERENCE_SETS.CHART_SET]: Array.from({ length: 1 }, (_, index) => `local_chart_set_${index}`),
  [USER_PREFERENCE_SETS.CHART]: Array.from({ length: 5 }, (_, index) => `local_chart_${index}`)
};

export const CHART_PLACEHOLDER_PAYLOAD = {
  preferenceId: localChartPlaceholder.preferenceId,
  name: localChartPlaceholder.name,
  category: localChartPlaceholder.category,
  local: localChartPlaceholder.local
};
